"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DataAccessor_1 = require("../../DOM/HTMLElement/DataAccessor");
(() => {
    const dataAccessor = new DataAccessor_1.default((context, key) => context.dataset[key], (context, key, value) => context.dataset[key] = value);
    HTMLElement.prototype.datamap = function datamap() {
        return {
            setString: (key, value) => dataAccessor.setString(this, key, value),
            setInt: (key, value) => dataAccessor.setInt(this, key, value),
            setFloat: (key, value) => dataAccessor.setFloat(this, key, value),
            setJson: (key, value) => dataAccessor.setJson(this, key, value),
            getString: (key, defaultValue) => dataAccessor.getString(this, key, defaultValue),
            getStringOrNull: (key, defaultValue) => dataAccessor.getStringOrNull(this, key, defaultValue),
            getInt: (key, defaultValue) => dataAccessor.getInt(this, key, defaultValue),
            getIntOrNull: (key, defaultValue) => dataAccessor.getIntOrNull(this, key, defaultValue),
            getFloat: (key, defaultValue) => dataAccessor.getFloat(this, key, defaultValue),
            getFloatOrNull: (key, defaultValue) => dataAccessor.getFloatOrNull(this, key, defaultValue),
            getDate: (key, defaultValue) => dataAccessor.getDate(this, key, defaultValue),
            getDateOrNull: (key, defaultValue) => dataAccessor.getDateOrNull(this, key, defaultValue),
            getJson: (key, defaultValue) => dataAccessor.getJson(this, key, defaultValue),
            getJsonOrNull: (key, defaultValue) => dataAccessor.getJsonOrNull(this, key, defaultValue),
            has: (key) => dataAccessor.has(this, key)
        };
    };
})();
//# sourceMappingURL=DataMap.js.map